module.exports = __webpack_public_path__ + "img/webinar.f2f5cff5.png";